module.exports = __webpack_public_path__ + "img/bg.f0111544.png";